import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'extractDecimal'
})
export class ExtractDecimalPipe implements PipeTransform {

  public transform(value: any) {
      let number = value.toString().split(".");
      return number[1];
  }
}
